export default "__VITE_ASSET__ChVQi_Uf__"